import i18n from "../../../constants/i18n";
import { DEVELOPER_AI_IMAGE_COMPARE_HEADERS } from "../../../constants/table-custom-headers/Developers";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import Et3Table from "../../../core/et3-table";
import getDebugAIData from "../../../stores/developer-store/debug-ai-data";

const DebugImageCompareData = withLiteObserverAndTheme(() => {
  const aiImageCompareData = getDebugAIData().imageCompareData.get();
  return (
    <Et3Table
      columns={DEVELOPER_AI_IMAGE_COMPARE_HEADERS}
      rows={aiImageCompareData}
      title={i18n.get("DEBUG_IMAGE_AI")}
      shouldBeFlagged={false}
      titleKey={"DEBUG_IMAGE_AI"}
    />
  );
});

export default DebugImageCompareData;
